import { BaseModel } from './base';

export class PaymentModel extends BaseModel {
  idPaymentModel!: number;
  name!: string;

  override objectID(): string | null {
    return this.idPaymentModel?.toString() ?? null;
  }
}
